import React from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import s from './styles.module.scss'

import { InputsSubscribeFinalized } from './form/SubscribeFinalizedModalForm'
import { SubscribeFinalizedModalForm } from './form/SubscribeFinalizedModalForm'
import { getTitle } from './utils/getTitle'
import { SubscribeFinalizedModalProps } from '../login.types'
import { Mixpanel } from '../../../../utils/Mixpanel'
import { pushToGTM } from '../../../../utils/pushToGTM'
import { Modal } from '../../../molecules'

export interface InputsAccessAccount {
  email: string
  firstname: string
  lastname: string
  password: string
}

const SubscribeFinalizedModal = ({
  setModalType,
  onSubscribe,
  isLoading,
  user,
  ssoOptions,
}: SubscribeFinalizedModalProps) => {
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<InputsSubscribeFinalized>({
    defaultValues: { email: user?.email ?? '' },
    mode: 'onChange',
  })
  const onSubmit: SubmitHandler<InputsAccessAccount> = async ({
    email,
    firstname,
    lastname,
    password,
  }) => {
    onSubscribe({ email, firstname, lastname, password })

    pushToGTM({
      event: 'simple_signup_finalized',
      email,
      firstname,
      lastname,
    })

    pushToGTM({
      event: 'subscribe',
      'register-form-email': email,
      'register-form-firstname': firstname,
      'register-form-lastname': lastname,
    })
    Mixpanel.identify(email)
    Mixpanel.alias(email)
    Mixpanel.people.set({
      $first_name: firstname,
      $last_name: lastname,
      $email: email,
    })
  }

  //it is possible to not have a user for invitations links sent to vote
  if (!user) {
    return null
  }

  return (
    <Modal
      isOpen={true}
      title={getTitle({ setModalType, user })}
      className={s.subscribeFinalizedModal}
      applyInnerStyle={false}
      navBar={getTitle({ setModalType, user })}
    >
      <SubscribeFinalizedModalForm
        control={control}
        isFormValid={isValid}
        handleOnSubmit={handleSubmit(onSubmit)}
        user={user}
        isLoading={isLoading}
        ssoOptions={ssoOptions}
      />
    </Modal>
  )
}

export default SubscribeFinalizedModal
